import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-one-third container-list-wrapper" }
const _hoisted_5 = { class: "s-card" }
const _hoisted_6 = { class: "level" }
const _hoisted_7 = { class: "level-right" }
const _hoisted_8 = { class: "level-item" }
const _hoisted_9 = { class: "tabs" }
const _hoisted_10 = { class: "is-active" }
const _hoisted_11 = { class: "control" }
const _hoisted_12 = { class: "radio pl-1" }
const _hoisted_13 = ["value", "checked"]
const _hoisted_14 = { class: "control" }
const _hoisted_15 = { class: "radio pl-1" }
const _hoisted_16 = ["value", "checked"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "control" }
const _hoisted_19 = { class: "radio pl-1" }
const _hoisted_20 = ["value", "checked"]
const _hoisted_21 = { class: "column" }
const _hoisted_22 = { class: "s-card wrapper-copy" }
const _hoisted_23 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UserIndexList = _resolveComponent("UserIndexList")!
  const _component_IndexList = _resolveComponent("IndexList")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LegVolumesHistoryPanel = _resolveComponent("LegVolumesHistoryPanel")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "level-left" }, [
                _createElementVNode("div", { class: "level-item" }, [
                  _createElementVNode("div", { class: "title" }, "Strategies")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    class: "button",
                    title: "Create a new strat",
                    to: "/stratslist/create/"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("span", { class: "icon" }, [
                        _createElementVNode("i", { class: "fas fa-plus" })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "icon" }, [
                      _createElementVNode("i", {
                        class: "fas fa-id-badge",
                        "aria-hidden": "true"
                      })
                    ], -1)),
                    _createElementVNode("label", _hoisted_12, [
                      _createElementVNode("input", {
                        type: "radio",
                        name: "tab",
                        value: _ctx.IndicesCategories.ASSIGNED,
                        checked: _ctx.tabvalue=== _ctx.IndicesCategories.ASSIGNED,
                        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setStratCategoryTab && _ctx.setStratCategoryTab(...args)))
                      }, null, 40, _hoisted_13),
                      _cache[5] || (_cache[5] = _createTextVNode(" My ", -1))
                    ])
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "icon" }, [
                      _createElementVNode("i", {
                        class: "fas fa-house-user",
                        "aria-hidden": "true"
                      })
                    ], -1)),
                    _createElementVNode("label", _hoisted_15, [
                      _createElementVNode("input", {
                        type: "radio",
                        name: "tab",
                        value: _ctx.IndicesCategories.HOUSE,
                        checked: _ctx.tabvalue === _ctx.IndicesCategories.HOUSE,
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setStratCategoryTab && _ctx.setStratCategoryTab(...args)))
                      }, null, 40, _hoisted_16),
                      _cache[7] || (_cache[7] = _createTextVNode(" House ", -1))
                    ])
                  ])
                ]),
                (_ctx.user.is_staff===true)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "icon" }, [
                          _createElementVNode("i", {
                            class: "fas fa-users",
                            "aria-hidden": "true"
                          })
                        ], -1)),
                        _createElementVNode("label", _hoisted_19, [
                          _createElementVNode("input", {
                            type: "radio",
                            name: "tab",
                            value: _ctx.IndicesCategories.USERS,
                            checked: _ctx.tabvalue === _ctx.IndicesCategories.USERS,
                            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setStratCategoryTab && _ctx.setStratCategoryTab(...args)))
                          }, null, 40, _hoisted_20),
                          _cache[9] || (_cache[9] = _createTextVNode(" Users ", -1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.tabvalue === _ctx.IndicesCategories.USERS)
              ? (_openBlock(), _createBlock(_component_UserIndexList, {
                  key: 0,
                  users: _ctx.users,
                  list: _ctx.indices,
                  onSelectUser: _ctx.setSelectedUser
                }, null, 8, ["users", "list", "onSelectUser"]))
              : (_openBlock(), _createBlock(_component_IndexList, {
                  key: 1,
                  list: _ctx.indices,
                  "indices-category": _ctx.tabvalue
                }, null, 8, ["list", "indices-category"]))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            (_ctx.isStratSelected)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_23, "No strategy selected"))
              : _createCommentVNode("", true),
            _createVNode(_component_router_view)
          ])
        ])
      ])
    ]),
    _createVNode(_component_LegVolumesHistoryPanel)
  ]))
}